import React, { createContext, useState } from "react";

export const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    profileDetails: {
      firstName: localStorage.getItem("name") || "",
      lastName: "",
      email: localStorage.getItem("userEmail") || "",
      mobileNumber: localStorage.getItem("phonenumber") || "",
      address: "",
      city: "",
      education: "",
      countryOfBirth: "",
      birthDate: "",
    },
  });

  const updateFormData = (newData) => {
    setFormData((prevData) => ({
      ...prevData,
      profileDetails: { ...prevData.profileDetails, ...newData },
    }));
  };

  return (
    <FormContext.Provider value={{ formData, updateFormData }}>
      {children}
    
    </FormContext.Provider>
  );
};
